<template>
  <div class="mbo-obs">
    <MbOverlayStage>
      <MbOverlay :scene="scene"
                 :battle="battle"
                 :post-battle="scene === 'post' ? battle : null"
                 :events="events"
                 :series="series"/>
    </MbOverlayStage>
  </div>
</template>

<script>
import api from '@/api/api'
import MbOverlay from '@/components/MlbbBroadcast/overlay/MbOverlay.vue'
import MbOverlayStage from '@/components/MlbbBroadcast/overlay/MbOverlayStage.vue'
import {createBattleLive} from '@/services/mlbbBattleLive'
import {loadHeroCatalog} from '@/services/mlbbHeroCatalog'
import {parseJudgeId} from '@/common/mlbbBroadcast'
import {followGame, suggestedScene} from '@/common/mlbbOverlay'

// следующую игру серии бэк отдельным событием не присылает — перечитываем список игр матча
const SERIES_POLL_MS = 20000
const ROOT_CLASS = 'mbo-obs-root'

/**
 * Вывод графики для OBS (Browser Source 1920×1080): без меню админки, на прозрачном фоне.
 * Сцена выбирается по состоянию игры; хранения выбора режиссёра на бэке нет.
 * Авторизация — токен судьи из localStorage: войти можно прямо в OBS через «Взаимодействовать».
 */
export default {
  name: 'MlbbObsPage',
  components: {MbOverlay, MbOverlayStage},
  data() {
    return {
      battleId: null,
      battle: null,
      events: [],
      series: [],
      live: null,
      seriesTimer: null,
    }
  },
  computed: {
    scene() {
      return suggestedScene(this.battle) || 'none'
    },
  },
  watch: {
    'battle.group_id'(groupId, prev) {
      if (groupId !== prev) this.loadSeries()
    },
    'battle.state'(state, prev) {
      if (state === 'end' && prev && prev !== 'end') this.loadSeries()
    },
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.replace({name: 'auth', query: {redirect: this.$route.fullPath}}).catch(() => {})
      return
    }
    loadHeroCatalog()
    const battleId = parseJudgeId(this.$route.query.battle)
    if (battleId) this.startLive(battleId)
  },
  mounted() {
    document.documentElement.classList.add(ROOT_CLASS)
    this.seriesTimer = setInterval(() => this.loadSeries(), SERIES_POLL_MS)
  },
  beforeDestroy() {
    document.documentElement.classList.remove(ROOT_CLASS)
    clearInterval(this.seriesTimer)
    this.stopLive()
  },
  methods: {
    startLive(battleId, initial = null) {
      this.stopLive()
      this.battleId = battleId
      // игра из списка серии — полный объект, показываем её сразу, без пустого кадра
      this.battle = initial && initial.id === battleId ? initial : null
      this.events = []
      this.live = createBattleLive({
        battleId,
        onBattle: (b) => {
          this.battle = b
        },
        onEvents: (all) => {
          this.events = all
        },
      })
      this.live.start().then(() => this.loadSeries())
    },

    stopLive() {
      if (this.live) this.live.stop()
      this.live = null
    },

    async loadSeries() {
      const groupId = this.battle?.group_id
      if (!groupId) {
        this.series = []
        return
      }
      try {
        const res = await api.mlbbEsports.groupBattles(groupId, {skipErrorToast: true})
        if (groupId !== this.battle?.group_id) return
        this.series = res?.data?.data || []
        const next = followGame(this.series, this.battleId)
        if (next) this.startLive(next.id, next)
      } catch (e) {
        // без серии остаётся текущая игра
      }
    },
  },
}
</script>

<style lang="scss">
html.mbo-obs-root,
html.mbo-obs-root body {
  margin: 0;
  overflow: hidden;
  background: transparent !important;
}

html.mbo-obs-root .loader-wrapper { display: none; }

.mbo-obs {
  width: 100vw;

  .mbo-stage {
    border-radius: 0;
    background: transparent;
  }
}
</style>
